var map = {
	"./bilibili.svg": "./src/assets/images/platforms/colored/bilibili.svg",
	"./boomstream.svg": "./src/assets/images/platforms/colored/boomstream.svg",
	"./breakerstv.svg": "./src/assets/images/platforms/colored/breakerstv.svg",
	"./custom.svg": "./src/assets/images/platforms/colored/custom.svg",
	"./cybergame.svg": "./src/assets/images/platforms/colored/cybergame.svg",
	"./discord.png": "./src/assets/images/platforms/colored/discord.png",
	"./discord.svg": "./src/assets/images/platforms/colored/discord.svg",
	"./djlive.png": "./src/assets/images/platforms/colored/djlive.png",
	"./dlive.svg": "./src/assets/images/platforms/colored/dlive.svg",
	"./facebook-live.svg": "./src/assets/images/platforms/colored/facebook-live.svg",
	"./gg.svg": "./src/assets/images/platforms/colored/gg.svg",
	"./instagib.svg": "./src/assets/images/platforms/colored/instagib.svg",
	"./lahzenegar.svg": "./src/assets/images/platforms/colored/lahzenegar.svg",
	"./linkedin.svg": "./src/assets/images/platforms/colored/linkedin.svg",
	"./liveedu.svg": "./src/assets/images/platforms/colored/liveedu.svg",
	"./livehouse.svg": "./src/assets/images/platforms/colored/livehouse.svg",
	"./livestream.svg": "./src/assets/images/platforms/colored/livestream.svg",
	"./meridix.svg": "./src/assets/images/platforms/colored/meridix.svg",
	"./mixcloud.svg": "./src/assets/images/platforms/colored/mixcloud.svg",
	"./mixer.svg": "./src/assets/images/platforms/colored/mixer.svg",
	"./mobcrush.svg": "./src/assets/images/platforms/colored/mobcrush.svg",
	"./nimotv.png": "./src/assets/images/platforms/colored/nimotv.png",
	"./nimotv.svg": "./src/assets/images/platforms/colored/nimotv.svg",
	"./now.svg": "./src/assets/images/platforms/colored/now.svg",
	"./periscope.png": "./src/assets/images/platforms/colored/periscope.png",
	"./periscope.svg": "./src/assets/images/platforms/colored/periscope.svg",
	"./phonelivestreaming.svg": "./src/assets/images/platforms/colored/phonelivestreaming.svg",
	"./picartotv.svg": "./src/assets/images/platforms/colored/picartotv.svg",
	"./sportscastr.svg": "./src/assets/images/platforms/colored/sportscastr.svg",
	"./steam.svg": "./src/assets/images/platforms/colored/steam.svg",
	"./switchboard.svg": "./src/assets/images/platforms/colored/switchboard.svg",
	"./thetatv.svg": "./src/assets/images/platforms/colored/thetatv.svg",
	"./trovo.svg": "./src/assets/images/platforms/colored/trovo.svg",
	"./twitch.svg": "./src/assets/images/platforms/colored/twitch.svg",
	"./twitter.svg": "./src/assets/images/platforms/colored/twitter.svg",
	"./ustream.svg": "./src/assets/images/platforms/colored/ustream.svg",
	"./vaperstv.svg": "./src/assets/images/platforms/colored/vaperstv.svg",
	"./vaughnlive.svg": "./src/assets/images/platforms/colored/vaughnlive.svg",
	"./vimeo-white-12dfb0dc.svg": "./src/assets/images/platforms/colored/vimeo-white-12dfb0dc.svg",
	"./vimeo.svg": "./src/assets/images/platforms/colored/vimeo.svg",
	"./vimmtv.png": "./src/assets/images/platforms/colored/vimmtv.png",
	"./vimmtv.svg": "./src/assets/images/platforms/colored/vimmtv.svg",
	"./vk.png": "./src/assets/images/platforms/colored/vk.png",
	"./vk.svg": "./src/assets/images/platforms/colored/vk.svg",
	"./webtv.svg": "./src/assets/images/platforms/colored/webtv.svg",
	"./younow.svg": "./src/assets/images/platforms/colored/younow.svg",
	"./youtube.svg": "./src/assets/images/platforms/colored/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/platforms/colored sync recursive ^\\.\\/.*$";